"use client";

// The global context for handling opening and closing the cart

import { createContext, useContext, useState } from "react";

interface CartOpenContextType {
  isCartOpen: boolean;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
  setCartOpen: (open: boolean) => void;
}

const CartOpenContext = createContext<CartOpenContextType | undefined>(undefined);

export function CartOpenProvider({ children }: { children: React.ReactNode }) {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const openCart = () => setIsCartOpen(true);
  const closeCart = () => setIsCartOpen(false);
  const toggleCart = () => setIsCartOpen((prev) => !prev);
  const setCartOpen = (open: boolean) => setIsCartOpen(open);

  return (
    <CartOpenContext.Provider
      value={{
        isCartOpen,
        openCart,
        closeCart,
        toggleCart,
        setCartOpen,
      }}
    >
      {children}
    </CartOpenContext.Provider>
  );
}

export function useCartOpen() {
  const context = useContext(CartOpenContext);
  if (context === undefined) {
    throw new Error("useCartOpen must be used within a CartOpenProvider");
  }
  return context;
}
